import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { AppealFeesInSummary } from '../../../../api/candidate/appeal/model';
import FormHeader from '../../../../components/form-items/FormHeader';
import FeeRow from './FeeRow';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(3),
    maxWidth: 960,
  },
  sectionTitle: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  smallLabel: {
    color: theme.color.text.textHeader,
  },
  bigLabel: {
    color: theme.color.text.textHeader,
    fontWeight: 800,
  },
  itemLabel: {
    color: theme.color.text.textHeader,
    fontWeight: 800,
  },
}));

const FeeDetails = ({ ...props }: AppealFeesInSummary) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className={classes.container}>
      <FormHeader title={t('appeal->>AppealSummary.FeeDetails.AppealFees')} />
      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            id="gstRegNo"
            keyText={t('appeal->>AppealSummary.FeeDetails.GstRegNo')}
            valueText={props.gstRegNo}
          />
        </Grid>
      </Grid>
      <FeeRow
        label={t('appeal->>AppealSummary.FeeDetails.TotalAppealFees')}
        value={!isMobile ? t('appeal->>AppealSummary.FeeDetails.AmountSGD') : ''}
        currencyDenomination={false}
        variant="header"
      />
      <FeeRow label={t('appeal->>AppealSummary.FeeDetails.GST')} value={props.totalGst || 'N/A'} />
      <FeeRow
        label={t('appeal->>AppealSummary.FeeDetails.TotalPayableFeeInclGst')}
        value={props.totalPayableFeeIncludingGST}
      />
      {props.gstAbsorbed !== '0.00' && (
        <FeeRow
          label={t('appeal->>AppealSummary.FeeDetails.GSTAbsorbed')}
          value={props.gstAbsorbed}
        />
      )}
      <FeeRow
        variant="footer"
        label={t('appeal->>AppealSummary.FeeDetails.TotalPayable')}
        value={props.totalPayable || 'N/A'}
      />
    </Box>
  );
};

export default FeeDetails;
